import { render, staticRenderFns } from "./OfmCompany.vue?vue&type=template&id=e04dcae8&"
import script from "./OfmCompany.vue?vue&type=script&lang=js&"
export * from "./OfmCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports